module.exports = function getResource(label, vars = []) {
    const resources = {
        noShippingAddressRequired: 'No shipping address or payment is required for this order. Please review your information before placing your order.',
        noPaymentRequired: 'No payment is required for this order. Please review your information before placing your order.',
        pleaseReviewOrder: `Please review your order information before ${vars[0]}`,
        termsConditions: 'Terms & Conditions',
        andText: ' and ',
        privacyPolicy: 'Privacy Policy',
        pleaseReviewOrderInfoText: 'Please review your order information before placing your order.',
        byPlacingOrderCaText: 'By placing your order, you agree to be bound by the ',
        termsOfPurchase: 'Terms of Purchase',
        termsOfUse: 'Terms of Use',
        iAgreeToSephora: 'I Agree to Sephora’s ',
        termsOfService: 'Terms of Service ',
        andConditionsOfUse: 'Conditions of Use, have read the ',
        noticeOfFinancialIncentive: 'Notice of Financial Incentive.',
        iAgreeToAutoReplenish: 'I Agree to the Auto-Replenish ',
        termsAndConditions: 'Terms & Conditions ',
        forTheSubscription: 'for the subscription and authorize us to charge your default payment method or another payment method on file. Your subscription continues until canceled. You can cancel at any time via the Auto-Replenish page in Your Account.'
    };
    return resources[label];
};
